import { Typography, Button } from "@mui/material";
import pic from "../Components/Assets/pic.png";
import vctr from "../Components/Assets/vctr.png";
import two from "../Components/Assets/two.png";
import ful from "../Components/Assets/ful.png";
import ansar1 from "../Components/Assets/ansar1.png";
import ansar from "../Components/Assets/ansar.png";
import { styled } from "@mui/system";
import { Box } from "@mui/system";
import React from "react";

const Tecnology = () => {
  const MyComponent = styled("Div")({
    fontSize: "15px",
    fontWeight: "700",
    lineHeight: "32px",
    letterSpacing: "0em",
    color: "#ffffff",
   
  });

  const Main = styled("div")({
    backgroundColor: "rgba(0, 221, 156, 0.03)",
    display: "flex",
    gap: "50px",
    position: "relative",
    width: "90%",
    padding: "20px 0px",
    left: "10%",
    borderTopLeftRadius: "200px",
    borderBottomLeftRadius: "200px",
  });
  return (
    <>
      <Box
        sx={{ backgroundColor: "rgba(10, 22, 25, 1)", }}
      >
        <Typography
          sx={{
            fontSize: "36px",
            fontWeight: "700",
            lineHeight: "54px",
            letterSpacing: "0em",
            textAlign: "center",
            color: "#F5FBF2",
            padding: "50px 0px",
          }}
        >
          How Do We Work Our System and Our Journey{" "}
        </Typography>
        <Main>
          {" "}
          <Box
            sx={{
              display: "flex",
              gap: "30px",
              width: "80%",
              alignItems: "center",
              margin: "0px 50px",
              flexWrap:{xs:"wrap",md:"nowrap"}
            }}
          >
            <Box>
              <img src={pic} alt="img" />
            </Box>
            <Box>
              {" "}
              <Typography sx={{ color: "#ffffff", fontSize: "24px" }}>
                Consulting
              </Typography>
              <MyComponent sx={{width:{xs:"auto",md:"53%"}}}>
                A Lorem Ipsum is simply dummy text of the printing and
                typesetting industry. Lorem Ipsum has been the industry's
                standard dummy text ever since the 1500s,{" "}
              </MyComponent>
            </Box>
            <Box>
              <img src={vctr} alt="img" />
            </Box>
          </Box>
        </Main>
        {/*  */}
        <Box
          sx={{
            backgroundColor: "rgba(0, 221, 156, 0.03)",
            display: "flex",
            gap: "50px",
            // position: "relative",
            width: "90%",
            padding: "20px 0px",
            // Right: "10%",
            borderTopRightRadius: "200px",
            borderBottomRightRadius: "200px",
            marginTop: "20px",
          }}
        >
          {" "}
          <Box
            sx={{
              display: "flex",
              gap: "30px",
              width: "80%",
              alignItems: "center",
              marginLeft: { xs: "10px", md: "180px" },
              flexWrap:{xs:"wrap",md:"nowrap"}
            }}
          >
            <Box>
              <img src={ful} alt="img" />
            </Box>
            <Box>
              {" "}
              <Typography
                sx={{
                  color: "#ffffff",
                  fontSize: "24px",
                  marginLeft: { xs: "0px", md: "66%" },
                }}
              >
                Research & Complaince
              </Typography>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "700",
                  lineHeight: "32px",
                  letterSpacing: "0em",
                  color: "#ffffff",
                  width: {xs:"100%",md:"53%"},
                  marginLeft: { xs: "0px", md: "50%" },
                }}
              >
                A Lorem Ipsum is simply dummy text of the printing and
                typesetting industry. Lorem Ipsum has been the industry's
                standard dummy text ever since the 1500s, when unknown
              </Typography>
            </Box>
            <Box>
              <img src={two} alt="img" />
            </Box>
          </Box>
        </Box>
        {/*  */}
        <Main sx={{ marginTop: "30px" }}>
          {" "}
          <Box
            sx={{
              display: "flex",
              gap: "30px",
              width: "80%",
              alignItems: "center",
              margin: "0px 50px",
              flexWrap:{xs:"wrap",md:"nowrap"}
            }}
          >
            <Box>
              <img src={ansar} alt="img" />
            </Box>
            <Box>
              {" "}
              <Typography sx={{ color: "#ffffff", fontSize: "24px" }}>
                Technology
              </Typography>
              <MyComponent sx={{width:{xs:"auto",md:"53%"}}}>
                A Lorem Ipsum is simply dummy text of the printing and
                typesetting industry. Lorem Ipsum has been the industry's
                standard dummy text ever since the 1500s, when an 
              </MyComponent>
            </Box>
            <Box>
              <img src={ansar1} alt="img" />
            </Box>
          </Box>
        </Main>
        <Button
          size="large"
          sx={{
            border: "2px solid lightgreen",
            color: "#fff",
            width: { xs: "70%", md: "15%" },
            margin: { xs: "50px 50px", md: "50px 40%" },
            boxShadow: { xs: "green  0px 5px 15px", md: "none" },
          }}
        >
          Learn More
        </Button>
      </Box>
    </>
  );
};

export default Tecnology;
